import { GeneralStyle } from '@website-builder/model/style/general-style';

export class SlideshowStyle extends GeneralStyle {
  boxShadow = '';
  boxDecoration = '';
  inverseStyle = '';
  setParallax = false;
  parallaxValues: number[];
  breakPoint: string;

  static normalize(styles: Partial<SlideshowStyle>): SlideshowStyle {
    const generalStyles: GeneralStyle = GeneralStyle.normalize(styles);
    const pureStyles = new SlideshowStyle();

    Object.assign(pureStyles, generalStyles);

    pureStyles.boxShadow = styles.boxShadow ?? pureStyles.boxShadow;
    pureStyles.boxDecoration = styles.boxDecoration ?? pureStyles.boxDecoration;
    pureStyles.inverseStyle = styles.inverseStyle ?? pureStyles.inverseStyle;
    pureStyles.setParallax = styles.setParallax ?? pureStyles.setParallax;
    pureStyles.parallaxValues = styles.parallaxValues ?? pureStyles.parallaxValues;
    pureStyles.breakPoint = styles.breakPoint ?? pureStyles.breakPoint;

    return pureStyles;
  }
}
